import { Button } from '@thanx/uikit/button'
import { Switch } from '@thanx/uikit/switch'
import { useStyletron } from '@thanx/uikit/theme'
import clsx from 'clsx'
import Badges from 'components/Badges'
import Spinner from 'components/Spinner'
import React from 'react'
import { Col, Row } from 'react-bootstrap-five'

type Props = {
  title: string
  // A styletron class for the page's own <h3>. The global `h3` rule
  // (stylesheets/_typography.scss) derives letter-spacing from a shared em
  // formula, which resolves to 0.75px at 24px — three times the 0.25px the
  // Order feedback Settings panes are drawn at. Scoped to the one heading
  // rather than re-tuning that global rule, which every other h3 in the app
  // shares.
  titleClassName?: string
  description?: React.ReactNode
  isLoading?: boolean
  contactButtonTitle?: string
  badges?: string[]
  badgeDescriptions?: string[]
  className?: string
  sidebar?: React.ReactNode
  showTitle?: boolean
  children: React.ReactNode
}

const CmsPage: React.FC<Props> = props => {
  const {
    title,
    titleClassName,
    description,
    isLoading = false,
    contactButtonTitle,
    badges,
    badgeDescriptions,
    className = '',
    sidebar,
    showTitle = true,
    children,
  } = props

  const [css] = useStyletron()

  return (
    <div className={className}>
      {showTitle && <h3 className={clsx('mt-0', titleClassName)}>{title}</h3>}
      <Spinner
        isLoading={isLoading}
        size="4x"
        className="text-center margin-top-huge"
      >
        <Row>
          <Col md={sidebar ? 9 : 12}>
            {description &&
              (typeof description === 'string' ? (
                <p
                  className="mb-m grey-70"
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                />
              ) : (
                <div className="mb-m grey-70">{description}</div>
              ))}
            <Badges
              className="mb-m"
              values={badges}
              badgeDescriptions={badgeDescriptions}
            />
            <div>{children}</div>
            <Switch condition={!!contactButtonTitle}>
              <Button
                onClick={() =>
                  window.open('mailto:merchant.support@thanx.com', '_blank')
                }
              >
                {contactButtonTitle}
              </Button>
            </Switch>
          </Col>
          <Switch condition={!!sidebar}>
            <Col md={3}>
              <div className={css({ width: '200px' })}>{sidebar}</div>
            </Col>
          </Switch>
        </Row>
      </Spinner>
    </div>
  )
}

export default CmsPage
